module.exports = __webpack_public_path__ + "img/23.5e27e617.jpg";